import React from "react";
import Greeting from "./Greeting";
import SamplePrompts from "./SamplePrompts";
import ChatSystemMessage from "./ChatSystemMessage";
import ChatInput from "./ChatInput";
import { useAppContext } from "../context/AppContext";

const Home = () => {
  const { isChatActive } = useAppContext();

  return (
    <div className="page-container">
      <div className="page-content">
        <div className="landing-view">
          {!isChatActive && (
            <>
              <Greeting /> <SamplePrompts />
            </>
          )}
          {isChatActive && <ChatSystemMessage />}
        </div>
      </div>

      <div className="chat-input-container">
        <ChatInput />
      </div>
    </div>
  );
};

export default Home;
